export default __webpack_public_path__ + "static/media/fastener-placement-square-trapezoid-reversed.4d0811fa.webp";